export default __webpack_public_path__ + "static/signed-372a0a73e338595501e9342ed5ac5da7.png";